import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { ThemeProvider } from '@mui/material/styles';
import { ApolloProvider } from '@apollo/client';
import theme from './common/theme';
import './common/css/style.css';
import App from './App';
import { apolloClient } from './core/infrastructure/apollo/client';
import { MetaPortal } from './core/infrastructure/common/Meta';
// eslint-disable-next-line no-unused-vars
import { BackgroundTasksProvider } from './core/presentation/context/BackgroundTasksContext';
// import { setTitleIcon } from './common/utils';

// setTitleIcon();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <MetaPortal />
    <ThemeProvider theme={theme}>
      <ApolloProvider client={apolloClient}>
        <BrowserRouter>
          <BackgroundTasksProvider>
            <ToastContainer />
            <App />
          </BackgroundTasksProvider>
        </BrowserRouter>
      </ApolloProvider>
    </ThemeProvider>
  </React.StrictMode>
);
